export const packageActionTypes = {
    STORE_PACKAGES: "STORE_PACKAGES",
    STORE_PACKAGE: "STORE_PACKAGE",
    STORE_OFFER: "STORE_OFFER",
    CLEAR: "CLEAR",
    RESET: "RESET",
    STORE_PACKAGE_NAMES: "STORE_PACKAGE_NAMES",
    STORE_PRODUCT_NAMES: "STORE_PRODUCT_NAMES",
    STORE_PACKAGE_VERSIONS: "STORE_PACKAGE_VERSIONS"
}